module.exports = __webpack_public_path__ + "img/report-page2.403153c0.svg";